import React, {Component} from 'react'

class HelperDarkBackground extends Component{
  render(){
    return (
      <div dangerouslySetInnerHTML={{__html: `
          <style>

            @media (max-width: 991px){
              #page{
                background: #222;
              }

              [class^="gnm-"] .white-at-small{
                color:white !important;
              }
            }
          </style>
      `}}/>
    )
  }
}

export default HelperDarkBackground



// WEBPACK FOOTER //
// ./app/components/custom/ssr/HelperDarkBackground/index.js